export const GAME_CENTER_HEADER_MODULE = {
  ACTION_TYPES: {
    countdown: 'countdown',
    changeDescriptionEntity: 'changeDescriptionEntity'
  },

  COMPETITOR_LOGO: {
    mobile: 48,
    desktop: 64
  },

  STAR_QUALIFIED_SIZE: 12
};